import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const BUSINESS = {
  name: "Sixty Finance",
  slogan: "Always by your side",
  logoUrl: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/7be7sfe8_Screenshot%202026-07-12%20at%2011.39.16%E2%80%AFam.png",
  phone: "0431 550 780",
  phoneHref: "tel:+61431550780",
  email: "dilraj@sixtyfinance.com",
  address: "5/10 Nova Court, Craigieburn VIC 3064",
  hours: "Mon–Fri · 9:00am – 5:00pm",
  suburb: "Craigieburn, Victoria",
  mapEmbedQuery: "5%2F10+Nova+Court,+Craigieburn+VIC+3064",
};

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("sf_admin_token", token);
  } else {
    localStorage.removeItem("sf_admin_token");
  }
}

export function getAdminToken() {
  return localStorage.getItem("sf_admin_token") || "";
}

export const adminApi = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers["X-Admin-Token"] = token;
  return config;
});
